__turbopack_context__.v({
  "app-container": "OrderStatusApp-module-scss-module__jWrJEq__app-container",
});
